import { SignupProps, SignupEditorProps, 
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  VarFieldConfig 
} from './Signup.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptSignupProps(originalProps: any): SignupProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  const originalPathVariables = originalProps?.pathVariables || {};
  
  // varFields 기본값 설정
  const defaultVarFields = {
    var01: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var02: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var03: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,      
      content: ""
    },
    var04: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var05: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var06: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var07: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var08: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var09: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    },
    var10: { 
      show: false, 
      label: "", 
      type: "input" as const, 
      options: [], 
      required: false,
      content: ""
    }
  };

  // varFields 데이터 소스 확인
  let varFields;
  
  // 1. varFields가 직접 전달된 경우 (최우선)
  if (originalProps?.varFields) {
    varFields = { ...defaultVarFields };
    
    // var01~var10를 각각 개별적으로 병합
    if (originalProps.varFields.var01) {
      varFields.var01 = { ...defaultVarFields.var01, ...originalProps.varFields.var01 };
    }
    if (originalProps.varFields.var02) {
      varFields.var02 = { ...defaultVarFields.var02, ...originalProps.varFields.var02 };
    }
    if (originalProps.varFields.var03) {
      varFields.var03 = { ...defaultVarFields.var03, ...originalProps.varFields.var03 };
    }
    if (originalProps.varFields.var04) {
      varFields.var04 = { ...defaultVarFields.var04, ...originalProps.varFields.var04 };
    }
    if (originalProps.varFields.var05) {
      varFields.var05 = { ...defaultVarFields.var05, ...originalProps.varFields.var05 };
    }
    if (originalProps.varFields.var06) {
      varFields.var06 = { ...defaultVarFields.var06, ...originalProps.varFields.var06 };
    }
    if (originalProps.varFields.var07) {
      varFields.var07 = { ...defaultVarFields.var07, ...originalProps.varFields.var07 };
    }
    if (originalProps.varFields.var08) {
      varFields.var08 = { ...defaultVarFields.var08, ...originalProps.varFields.var08 };
    }
    if (originalProps.varFields.var09) {
      varFields.var09 = { ...defaultVarFields.var09, ...originalProps.varFields.var09 };
    }
    if (originalProps.varFields.var10) {
      varFields.var10 = { ...defaultVarFields.var10, ...originalProps.varFields.var10 };
    }
  }
  // 2. componentProps 내에 varFields가 있는 경우 (두번째 우선)
  else if (originalComponentProps?.varFields) {
    varFields = { ...defaultVarFields };
    
    // var01~var10를 각각 개별적으로 병합
    if (originalComponentProps.varFields.var01) {
      varFields.var01 = { ...defaultVarFields.var01, ...originalComponentProps.varFields.var01 };
    }
    if (originalComponentProps.varFields.var02) {
      varFields.var02 = { ...defaultVarFields.var02, ...originalComponentProps.varFields.var02 };
    }
    if (originalComponentProps.varFields.var03) {
      varFields.var03 = { ...defaultVarFields.var03, ...originalComponentProps.varFields.var03 };
    }
    if (originalComponentProps.varFields.var04) {
      varFields.var04 = { ...defaultVarFields.var04, ...originalComponentProps.varFields.var04 };
    }
    if (originalComponentProps.varFields.var05) {
      varFields.var05 = { ...defaultVarFields.var05, ...originalComponentProps.varFields.var05 };
    }
    if (originalComponentProps.varFields.var06) {
      varFields.var06 = { ...defaultVarFields.var06, ...originalComponentProps.varFields.var06 };
    }
    if (originalComponentProps.varFields.var07) {
      varFields.var07 = { ...defaultVarFields.var07, ...originalComponentProps.varFields.var07 };
    }
    if (originalComponentProps.varFields.var08) {
      varFields.var08 = { ...defaultVarFields.var08, ...originalComponentProps.varFields.var08 };
    }
    if (originalComponentProps.varFields.var09) {
      varFields.var09 = { ...defaultVarFields.var09, ...originalComponentProps.varFields.var09 };
    }
    if (originalComponentProps.varFields.var10) {
      varFields.var10 = { ...defaultVarFields.var10, ...originalComponentProps.varFields.var10 };
    }
  }
  // 3. 기본값 사용
  else {
    varFields = { ...defaultVarFields };
  }
  

  
  // 기본 회원정보 필드 표시 설정 처리
  const defaultBasicFields = {
    userId: true,
    password: true,
    name: true,
    phone: true,
    email: true,
    birthday: true,
    address: true,
    referralCode: true
  };

  // basicFields 병합 - PropertyPanel에서 설정한 최상위 basicFields 우선
  const basicFields = {
    ...defaultBasicFields,
    ...(originalComponentProps?.basicFields || {}),
    ...(originalProps?.basicFields || {})  // PropertyPanel에서 설정한 값이 최종적으로 적용
  };

  
  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';

  // Extract skin options if they exist
  const skinOptions = originalProps?.skinOptions || originalComponentProps?.skinOptions || {};

  // 변환된 props 반환
  const adaptedProps: SignupProps = {
    content: { 
      ...originalContent 
    },
    style,
    className,
    data: originalData,
    componentProps: {
      ...originalComponentProps,
    },
    pathVariables: originalPathVariables,
    varFields,
    id: originalProps?.id || '',
    basicFields,
    skinOptions, // Add skin options
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'id', 'pathVariables', 'varFields', 'basicFields'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptSignupEditorProps(originalProps: any): SignupEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptSignupProps(originalProps) as SignupProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 